// extracted by css-extract-rspack-plugin
export default {"discussionLink":"ConvertedToDiscussionEvent-module__discussionLink__nqsRFUN"};